import { useCallback } from "react";
import { Alert, BackHandler, Linking } from "react-native";

import { getLastVersion } from "@/services/versionCheck";
import { isNativeDevice } from "@/utils/platform";

export function useVersionCheck() {
  const checkForUpdates = useCallback(() => {
    if (isNativeDevice) {
      getLastVersion().then((res) => {
        if (res.updateRequired) {
          Alert.alert(
            "Atualização disponível!",
            "Há uma nova versão do iFeira disponível. Por favor, atualize para continuar",
            [
              {
                text: "Cancelar",
                onPress: () => BackHandler.exitApp(),
              },
              {
                text: "Atualizar",
                onPress: () => Linking.openURL(res.storeUrl),
              },
            ]
          );
        }
      });
    }
  }, []);

  return { checkForUpdates };
}
